import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import BasesInput from './pages/BasesInput.jsx';
import AssemblyExport from './pages/AssemblyExport.jsx';
import Expediente from './pages/Expediente.jsx';
import Login from './pages/Login';
import Settings from './pages/Settings';
import Landing from './pages/LandingPremium.jsx';
import AdminDashboard from './pages/AdminDashboard.jsx';
import Onboarding from './pages/Onboarding.jsx';
import { AuthProvider, useAuth } from './context/AuthContext';

const ProtectedRoute = ({ children, requireOnboarding = true, blockIfNoConfig = false }) => {
  const { user, userProfile, loading } = useAuth();

  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Cargando...</div>;
  if (!user) return <Navigate to="/login" />;

  // Si requiere onboarding y el perfil está cargado pero no tiene RUC configurado
  if (requireOnboarding && userProfile && !userProfile.onboardingCompleted && userProfile.role !== 'admin') {
      return <Navigate to="/onboarding" />;
  }

  // Sub-cuentas marcadas "sin configuración" no acceden a /settings
  if (blockIfNoConfig && userProfile?.sinConfiguracion) {
      return <Navigate to="/dashboard" />;
  }

  return children;
};

const AppLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <div className="layout-container">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      {sidebarOpen && <div className={`sidebar-overlay ${sidebarOpen ? 'open' : ''}`} onClick={toggleSidebar}></div>}
      <div className="main-content">
        <Header onMenuClick={toggleSidebar} />
        <main style={{ padding: '2rem', flex: 1 }}>{children}</main>
        <footer style={{ textAlign: 'center', padding: '1rem', color: '#6b7280', fontSize: '0.875rem', borderTop: '1px solid #e5e7eb', marginTop: 'auto' }}>
          KREO IA Studio - 2026 - El Gem SEACE
        </footer>
      </div>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<ProtectedRoute requireOnboarding={false}><AppLayout><AdminDashboard /></AppLayout></ProtectedRoute>} />
          
          {/* Onboarding */}
          <Route path="/onboarding" element={<ProtectedRoute requireOnboarding={false}><AppLayout><Onboarding /></AppLayout></ProtectedRoute>} />
          
          {/* App Routes */}
          <Route path="/dashboard" element={<ProtectedRoute><AppLayout><Dashboard /></AppLayout></ProtectedRoute>} />
          <Route path="/bases" element={<ProtectedRoute><AppLayout><BasesInput /></AppLayout></ProtectedRoute>} />
          <Route path="/expediente/:id" element={<ProtectedRoute><AppLayout><Expediente /></AppLayout></ProtectedRoute>} />
          <Route path="/exportar" element={<ProtectedRoute><AppLayout><AssemblyExport /></AppLayout></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute blockIfNoConfig><AppLayout><Settings /></AppLayout></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;

